import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';
import { GenericService } from 'src/app/services/generic.service';
import { videoURL } from 'src/app/services/base-url';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-episode-workflow',
  templateUrl: './episode-workflow.component.html',
  styleUrls: ['./episode-workflow.component.css']
})
export class EpisodeWorkflowComponent implements OnInit {

  statusMap: any = {
    'CREATED': 'Created',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  workflowSteps = [
    { stage: 'EPISODE_CREATION', label: 'Shoot' },
    { stage: 'EDITOR', label: 'Edit' },
    { stage: 'GRAPHICS', label: 'Graphics' },
    { stage: 'TITLE', label: 'Title' },
    { stage: 'QUALITY_CHECK', label: 'Quality Check' },
    { stage: 'SEO', label: 'SEO' },
    { stage: 'COMPLETED', label: 'Completed' }
  ];

  isStageCompleted(currentStage: string, stepStage: string): boolean {
    if (!currentStage) currentStage = 'EPISODE_CREATION';
    if (stepStage === 'COMPLETED') {
      return currentStage === 'COMPLETED';
    }
    const stageOrder = ['EPISODE_CREATION', 'EDITOR', 'GRAPHICS', 'TITLE', 'QUALITY_CHECK', 'SEO', 'PUBLISHING', 'COMPLETED'];
    const currentIndex = stageOrder.indexOf(currentStage);
    const stepIndex = stageOrder.indexOf(stepStage);
    if (currentIndex === -1 || stepIndex === -1) return false;
    return currentIndex > stepIndex || currentStage === 'COMPLETED';
  }

  isStageActive(currentStage: string, stepStage: string): boolean {
    if (!currentStage) currentStage = 'EPISODE_CREATION';
    return currentStage === stepStage;
  }

  episodeTypes: string[] = [
    'Full Episode',
    'Interview',
    'Shorts',
    'Live Event',
    'Promo',
    'News'
  ];

  episodeList: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  isLoading: boolean = false;

  // For action controls
  actionControls: any = {
    isAdd: true,
    isView: true,
    isDelete: true,
    isModify: true
  };

  searchFilter: string = "";

  // Forms
  episodeForm: any | FormGroup;
  episodeUpdateForm: any | FormGroup;

  formSubmit: boolean = false;
  isEdit: boolean = false;
  cid: any;

  // View & Delete state
  singleEpisodeData: any = [];
  deleteId: any = "";
  recordId: any = "";
  recordName: any = "";

  userList: any[] = [];
  editorUserList: any[] = [];
  titleUserList: any[] = [];
  graphicsUserList: any[] = [];
  seoUserList: any[] = [];
  qualityCheckUserList: any[] = [];
  publishingUserList: any[] = [];
  anchorUserList: any[] = [];
  directorUserList: any[] = [];
  selectedUserIdToAssign: any = "";
  selectedAssetsToAssign: any[] = [];
  cameraAssetsList: any[] = [];
  loggedInUserId: any;
  videoUrl: any = videoURL;
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectInfoId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };


  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private genericService: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'));
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.episodeForm = this.fb.group({
      episodeName: ['', [Validators.required]],
      episodeType: ['', [Validators.required]],
      episodeYouTubeURL: [''],
      anchorUser: ['', [Validators.required]],
      guest1: [''],
      guest2: [''],
      director: ['', [Validators.required]],
      shootDate: ['', [Validators.required]],
      shootTime: ['', [Validators.required]],
      outDoor: [false],
      assignToCameraManOnDate: [''],
      cameraManUser: [''],
      cameraManStartDate: [''],
      cameraManEndDate: [''],
      noOfDaysWithCameraman: [0],
      noOfHoursWithCameraman: [0],
      listOfAssetsTakenWithThem: [[]],
      assetsRecievedOn: [''],
      assetsReturnedOn: [''],
      assignToPcrOnDate: [''],
      pcrUser: [''],
      pcrStartDate: [''],
      pcrEndDate: [''],
      noOfDaysInPcr: [0],
      noOfHoursInPcr: [0]
    });

    this.episodeUpdateForm = this.fb.group({
      episodeName: ['', [Validators.required]],
      episodeType: ['', [Validators.required]],
      episodeYouTubeURL: [''],
      anchorUser: ['', [Validators.required]],
      guest1: [''],
      guest2: [''],
      director: ['', [Validators.required]],
      shootDate: ['', [Validators.required]],
      shootTime: ['', [Validators.required]],
      outDoor: [false],
      assignToCameraManOnDate: [''],
      cameraManUser: [''],
      cameraManStartDate: [''],
      cameraManEndDate: [''],
      noOfDaysWithCameraman: [0],
      noOfHoursWithCameraman: [0],
      listOfAssetsTakenWithThem: [[]],
      assetsRecievedOn: [''],
      assetsReturnedOn: [''],
      assignToPcrOnDate: [''],
      pcrUser: [''],
      pcrStartDate: [''],
      pcrEndDate: [''],
      noOfDaysInPcr: [0],
      noOfHoursInPcr: [0]
    });

    this.getAllEpisodes();
    this.getAllUsers();
    this.getAllObjectInfo();
  }

  getAllObjectInfo() {
    this.genericService.getAllObjectInfo().subscribe(
      (response: any) => {
        this.cameraAssetsList = response.response || [];
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  getAllUsers() {
    this.genericService.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        console.log(res)
        if (res && res.response) {
          this.userList = res.response;
          this.editorUserList = this.userList.filter((u: any) => u.userType === 'EDITOR');
          this.titleUserList = this.userList.filter((u: any) => u.userType === 'DIRECTOR');
          this.graphicsUserList = this.userList.filter((u: any) => u.userType === 'GRAPHICS');
          this.seoUserList = this.userList.filter((u: any) => u.userType === 'SEO');
          this.qualityCheckUserList = this.userList.filter((u: any) => u.userType === 'DIRECTOR');
          this.publishingUserList = this.userList.filter((u: any) => u.userType === 'PUBLISHING');
          this.anchorUserList = this.userList.filter((u: any) => u.userType === 'ANCHOR');
          this.directorUserList = this.userList.filter((u: any) => u.userType === 'DIRECTOR');
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  getAllEpisodes() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllEpisodes().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response;
          this.totalRecords = res.response.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    this.getAllEpisodes();
  }

  formatDateValue(timestamp: any): string {
    if (!timestamp) return '';
    let dateObj = new Date(timestamp);
    let year = dateObj.getFullYear();
    let month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
    let day = ('0' + dateObj.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  getEpisodeById(tvProductionTrackerId: any, isView: boolean = false) {
    this.tvProductionTrackerService.getEpisodeById(tvProductionTrackerId).subscribe(
      (res: any) => {
        const episode = res.response;
        if (isView) {
          this.singleEpisodeData = [episode];
        } else {
          this.singleEpisodeData = [episode];
          this.isEdit = true;

          let formattedEpisode = { ...episode };
          if (formattedEpisode.shootDate) {
            formattedEpisode.shootDate = this.formatDateValue(formattedEpisode.shootDate);
          }
          if (formattedEpisode.assignToPcrOnDate) {
            formattedEpisode.assignToPcrOnDate = this.formatDateValue(formattedEpisode.assignToPcrOnDate);
          }
          if (formattedEpisode.pcrStartDate) {
            formattedEpisode.pcrStartDate = this.formatDateValue(formattedEpisode.pcrStartDate);
          }
          if (formattedEpisode.pcrEndDate) {
            formattedEpisode.pcrEndDate = this.formatDateValue(formattedEpisode.pcrEndDate);
          }
          if (formattedEpisode.assignToCameraManOnDate) {
            formattedEpisode.assignToCameraManOnDate = this.formatDateValue(formattedEpisode.assignToCameraManOnDate);
          }
          if (formattedEpisode.cameraManStartDate) {
            formattedEpisode.cameraManStartDate = this.formatDateValue(formattedEpisode.cameraManStartDate);
          }
          if (formattedEpisode.cameraManEndDate) {
            formattedEpisode.cameraManEndDate = this.formatDateValue(formattedEpisode.cameraManEndDate);
          }
          if (formattedEpisode.assetsRecievedOn) {
            formattedEpisode.assetsRecievedOn = this.formatDateValue(formattedEpisode.assetsRecievedOn);
          }
          if (formattedEpisode.assetsReturnedOn) {
            formattedEpisode.assetsReturnedOn = this.formatDateValue(formattedEpisode.assetsReturnedOn);
          }
          if (formattedEpisode.listOfAssetsTakenWithThem && Array.isArray(formattedEpisode.listOfAssetsTakenWithThem)) {
            formattedEpisode.listOfAssetsTakenWithThem = formattedEpisode.listOfAssetsTakenWithThem.join(',');
          }

          this.episodeUpdateForm.patchValue(formattedEpisode);
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  viewEpisodeById(id: any) {
    this.getEpisodeById(id, true);
  }

  addEpisode() {
    if (this.formSubmit) return;
    this.formSubmit = true;

    if (this.episodeForm.invalid) {
      this.episodeForm.markAllAsTouched();
      this.toastr.error("Please fill required fields");
      this.formSubmit = false;
      return;
    }

    const payload = {
      version: 0,
      isActive: true,
      description: "",
      episodeId: 0,
      episodeName: this.episodeForm.get('episodeName').value,
      episodeType: this.episodeForm.get('episodeType').value,
      episodeStatus: 'CREATED',
      episodePublishedOn: 0,
      episodeYouTubeURL: this.episodeForm.get('episodeYouTubeURL').value,
      anchorUser: this.episodeForm.get('anchorUser').value,
      guest1: this.episodeForm.get('guest1').value,
      guest2: this.episodeForm.get('guest2').value,
      director: this.episodeForm.get('director').value,
      shootDate: this.episodeForm.get('shootDate').value ? new Date(this.episodeForm.get('shootDate').value).getTime() : 0,
      shootTime: this.episodeForm.get('shootTime').value,
      assignToEditorOnDate: 0,
      editorUser: "",
      editStartDate: 0,
      editEndDate: 0,
      noOfDaysToEdit: 0,
      noOfHoursToEdit: 0,
      assignToTitleTeamOnDate: 0,
      titleCreationStartDate: 0,
      titleCreationEndDate: 0,
      titleCreationUser: "",
      suggestedTitles: [],
      approvedTitle: "",
      assignToGraphicsTeamOnDate: 0,
      graphicsUser: "",
      graphicsCreationStartDate: 0,
      graphicsCreationEndDate: 0,
      assignToSEOTeamOnDate: 0,
      seoTeamStartDate: 0,
      seoTeamEndDate: 0,
      seoUser: "",
      suggestedSEOTitles: [],
      approvedSeoTitle: "",
      qualityCheckUser: "",
      assignToQualityCheckTeamOnDate: 0,
      qualityCheckStartDate: 0,
      publishingUser: "",
      assignToPublishingTeamOnDate: 0,
      publishingStartDate: 0,
      publishingEndDate: 0,
      editDueDate: 0,
      episodeDueDate: 0,
      titleDueDate: 0,
      graphicsDueDate: 0,
      seoDueDate: 0,
      qualityDueDate: 0,
      publishingDueDate: 0,
      commonNotes: [],
      currentStage: "EPISODE_CREATION",
      priority: "LOW",
      workflowStatus: "IN_PROGRESS",
      assignedUserId: 0,
      cid: this.cid,
      outDoor: this.episodeForm.get('outDoor')?.value || false,
      assignToPcrOnDate: this.episodeForm.get('assignToPcrOnDate')?.value ? new Date(this.episodeForm.get('assignToPcrOnDate').value).getTime() : 0,
      pcrUser: this.episodeForm.get('pcrUser')?.value || "",
      pcrStartDate: this.episodeForm.get('pcrStartDate')?.value ? new Date(this.episodeForm.get('pcrStartDate').value).getTime() : 0,
      pcrEndDate: this.episodeForm.get('pcrEndDate')?.value ? new Date(this.episodeForm.get('pcrEndDate').value).getTime() : 0,
      noOfDaysInPcr: this.episodeForm.get('noOfDaysInPcr')?.value || 0,
      noOfHoursInPcr: this.episodeForm.get('noOfHoursInPcr')?.value || 0,
      assignToCameraManOnDate: this.episodeForm.get('assignToCameraManOnDate')?.value ? new Date(this.episodeForm.get('assignToCameraManOnDate').value).getTime() : 0,
      cameraManUser: this.episodeForm.get('cameraManUser')?.value || "",
      cameraManStartDate: this.episodeForm.get('cameraManStartDate')?.value ? new Date(this.episodeForm.get('cameraManStartDate').value).getTime() : 0,
      cameraManEndDate: this.episodeForm.get('cameraManEndDate')?.value ? new Date(this.episodeForm.get('cameraManEndDate').value).getTime() : 0,
      noOfDaysWithCameraman: this.episodeForm.get('noOfDaysWithCameraman')?.value || 0,
      noOfHoursWithCameraman: this.episodeForm.get('noOfHoursWithCameraman')?.value || 0,
      listOfAssetsTakenWithThem: (typeof this.episodeForm.get('listOfAssetsTakenWithThem')?.value === 'string') ? this.episodeForm.get('listOfAssetsTakenWithThem')?.value.split(',').filter((i: string) => i.trim() !== '') : [],
      assetsRecievedOn: this.episodeForm.get('assetsRecievedOn')?.value ? new Date(this.episodeForm.get('assetsRecievedOn').value).getTime() : 0,
      assetsReturnedOn: this.episodeForm.get('assetsReturnedOn')?.value ? new Date(this.episodeForm.get('assetsReturnedOn').value).getTime() : 0
    };

    this.tvProductionTrackerService.createEpisode(payload).subscribe(
      (res: any) => {
        this.formSubmit = false;
        this.episodeForm.reset();
        this.closePopUp();
        this.getAllEpisodes();
        this.toastr.success(res.message || 'Episode created successfully');
      },
      (err: any) => {
        this.formSubmit = false;
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error creating episode');
      }
    );
  }

  updateEpisode() {
    if (this.formSubmit) return;
    this.formSubmit = true;

    if (this.episodeUpdateForm.invalid) {
      this.episodeUpdateForm.markAllAsTouched();
      this.toastr.error("Please fill required fields");
      this.formSubmit = false;
      return;
    }

    const payload: any = {
      ...this.singleEpisodeData[0],
      commonNotes: this.singleEpisodeData[0].commonNotes || [],
      episodeName: this.episodeUpdateForm.get('episodeName').value,
      episodeType: this.episodeUpdateForm.get('episodeType').value,
      episodeYouTubeURL: this.episodeUpdateForm.get('episodeYouTubeURL').value,
      anchorUser: this.episodeUpdateForm.get('anchorUser').value,
      guest1: this.episodeUpdateForm.get('guest1').value,
      guest2: this.episodeUpdateForm.get('guest2').value,
      director: this.episodeUpdateForm.get('director').value,
      shootDate: this.episodeUpdateForm.get('shootDate').value ? new Date(this.episodeUpdateForm.get('shootDate').value).getTime() : 0,
      shootTime: this.episodeUpdateForm.get('shootTime').value,
      cid: this.cid,
      outDoor: this.episodeUpdateForm.get('outDoor')?.value || false,
      assignToPcrOnDate: this.episodeUpdateForm.get('assignToPcrOnDate')?.value ? new Date(this.episodeUpdateForm.get('assignToPcrOnDate').value).getTime() : 0,
      pcrUser: this.episodeUpdateForm.get('pcrUser')?.value || "",
      pcrStartDate: this.episodeUpdateForm.get('pcrStartDate')?.value ? new Date(this.episodeUpdateForm.get('pcrStartDate').value).getTime() : 0,
      pcrEndDate: this.episodeUpdateForm.get('pcrEndDate')?.value ? new Date(this.episodeUpdateForm.get('pcrEndDate').value).getTime() : 0,
      noOfDaysInPcr: this.episodeUpdateForm.get('noOfDaysInPcr')?.value || 0,
      noOfHoursInPcr: this.episodeUpdateForm.get('noOfHoursInPcr')?.value || 0,
      assignToCameraManOnDate: this.episodeUpdateForm.get('assignToCameraManOnDate')?.value ? new Date(this.episodeUpdateForm.get('assignToCameraManOnDate').value).getTime() : 0,
      cameraManUser: this.episodeUpdateForm.get('cameraManUser')?.value || "",
      cameraManStartDate: this.episodeUpdateForm.get('cameraManStartDate')?.value ? new Date(this.episodeUpdateForm.get('cameraManStartDate').value).getTime() : 0,
      cameraManEndDate: this.episodeUpdateForm.get('cameraManEndDate')?.value ? new Date(this.episodeUpdateForm.get('cameraManEndDate').value).getTime() : 0,
      noOfDaysWithCameraman: this.episodeUpdateForm.get('noOfDaysWithCameraman')?.value || 0,
      noOfHoursWithCameraman: this.episodeUpdateForm.get('noOfHoursWithCameraman')?.value || 0,
      listOfAssetsTakenWithThem: (typeof this.episodeUpdateForm.get('listOfAssetsTakenWithThem')?.value === 'string') ? this.episodeUpdateForm.get('listOfAssetsTakenWithThem')?.value.split(',').filter((i: string) => i.trim() !== '') : [],
      assetsRecievedOn: this.episodeUpdateForm.get('assetsRecievedOn')?.value ? new Date(this.episodeUpdateForm.get('assetsRecievedOn').value).getTime() : 0,
      assetsReturnedOn: this.episodeUpdateForm.get('assetsReturnedOn')?.value ? new Date(this.episodeUpdateForm.get('assetsReturnedOn').value).getTime() : 0
    };
    delete payload.episodeNotes;
    delete payload.editorNotes;
    delete payload.titleNotes;
    delete payload.graphicsNotes;
    delete payload.seoNotes;
    delete payload.qualityCheckNotes;
    delete payload.publishingNotes;

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.isEdit = false;
        this.formSubmit = false;
        this.episodeUpdateForm.reset();
        this.closePopUp();
        this.getAllEpisodes();
        this.toastr.success(res.message || 'Episode updated successfully');
      },
      (err: any) => {
        this.formSubmit = false;
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error updating episode');
      }
    );
  }

  assignToCameraman() {
    if (!this.selectedUserIdToAssign) {
      this.toastr.error("Please select a cameraman to assign.");
      return;
    }

    const selectedUserId = this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId;
    if (!selectedUserId) {
      this.toastr.error("Cameraman not found.");
      return;
    }

    const selectedEpisode = this.singleEpisodeData[0];
    if (!selectedEpisode) return;

    const payload = {
      ...selectedEpisode,
      currentStage: "CAMERA_MAN_NOTE",
      episodeStatus: "CAMERAMAN_ASSIGNED",
      cameraManUser: this.selectedUserIdToAssign,
      assignedUserId: Number(selectedUserId),
      assignToCameraManOnDate: new Date().getTime(),
      cameraManStartDate: new Date().getTime(),
      cameraManEndDate: new Date().getTime() + (2 * 24 * 60 * 60 * 1000), // Default to 2 days later
      noOfDaysWithCameraman: 2,
      noOfHoursWithCameraman: 48,
      listOfAssetsTakenWithThem: this.selectedAssetsToAssign ? this.selectedAssetsToAssign.map((asset: any) => asset.objectInfoId) : [],
      assetsRecievedOn: new Date().getTime(),
      assetsReturnedOn: 0,
      cid: this.cid
    };

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success("Episode assigned to Cameraman successfully!");
        this.getAllEpisodes();
        this.selectedUserIdToAssign = "";
        this.selectedAssetsToAssign = [];
        document.getElementById("closeViewModalButton")?.click();
      },
      (err: any) => {
        console.error(err);
        this.toastr.error("Failed to assign episode.");
      }
    );
  }

  assignToPcr() {
    if (!this.selectedUserIdToAssign) {
      this.toastr.error("Please select a PCR user to assign.");
      return;
    }

    const selectedUserId = this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId;
    if (!selectedUserId) {
      this.toastr.error("PCR user not found.");
      return;
    }

    const selectedEpisode = this.singleEpisodeData[0];
    if (!selectedEpisode) return;

    const payload = {
      ...selectedEpisode,
      currentStage: "PCR_NOTE",
      episodeStatus: "PCR_ASSIGNED",
      pcrUser: this.selectedUserIdToAssign,
      assignedUserId: Number(selectedUserId),
      assignToPcrOnDate: new Date().getTime(),
      pcrStartDate: new Date().getTime(),
      cid: this.cid
    };

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success("Episode assigned to PCR successfully!");
        this.getAllEpisodes();
        this.selectedUserIdToAssign = "";
        document.getElementById("closeViewModalButton")?.click();
      },
      (err: any) => {
        console.error(err);
        this.toastr.error("Failed to assign episode.");
      }
    );
  }

  assignToEditor() {
    if (!this.selectedUserIdToAssign) {
      this.toastr.error("Please select an editor to assign.");
      return;
    }

    const selectedUserId = this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId;
    if (!selectedUserId) {

      this.toastr.error("Editor not found.");
      return;
    }

    const selectedEpisode = this.singleEpisodeData[0];
    if (!selectedEpisode) return;

    // Use full payload to update
    const payload = {
      ...selectedEpisode,
      currentStage: "EDITOR",
      episodeStatus: "EDITOR_ASSIGNED",
      editorUser: this.selectedUserIdToAssign,
      assignedUserId: Number(selectedUserId),
      assignToEditorOnDate: new Date().getTime(),
      editStartDate: new Date().getTime(),
      editDueDate: new Date().getTime() + (2 * 24 * 60 * 60 * 1000),
      cid: this.cid
    };

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success("Episode assigned to Editor successfully!");
        this.getAllEpisodes();
        this.selectedUserIdToAssign = "";
        document.getElementById("closeViewModalButton")?.click();
      },
      (err: any) => {
        console.error(err);
        this.toastr.error("Failed to assign episode.");
      }
    );
  }

  assignToTitle() {
    if (!this.selectedUserIdToAssign) {
      this.toastr.error("Please select a title user to assign.");
      return;
    }

    const selectedUserId = this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId;
    if (!selectedUserId) {

      this.toastr.error("Title user not found.");
      return;
    }

    const selectedEpisode = this.singleEpisodeData[0];
    if (!selectedEpisode) return;
    const payload = {
      ...selectedEpisode,
      currentStage: "TITLE",
      titleCreationUser: this.selectedUserIdToAssign,
      assignedUserId: Number(selectedUserId),
      assignToTitleTeamOnDate: new Date().getTime(),
      titleCreationStartDate: new Date().getTime(),
      titleDueDate: new Date().getTime() + (2 * 24 * 60 * 60 * 1000),
      cid: this.cid
    };
    this.updateWorkflowAssignment(payload, "Title");
  }

  assignToGraphics() {
    if (!this.selectedUserIdToAssign) {
      this.toastr.error("Please select a graphics user to assign.");
      return;
    }


    const selectedUserId = this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId;
    if (!selectedUserId) {

      this.toastr.error("Graphics user not found.");
      return;
    }

    const selectedEpisode = this.singleEpisodeData[0];
    if (!selectedEpisode) return;
    const payload = {
      ...selectedEpisode,
      currentStage: "GRAPHICS",
      graphicsUser: this.selectedUserIdToAssign,
      assignedUserId: Number(selectedUserId),
      assignToGraphicsTeamOnDate: new Date().getTime(),
      graphicsCreationStartDate: new Date().getTime(),
      graphicsDueDate: new Date().getTime() + (2 * 24 * 60 * 60 * 1000),
      cid: this.cid
    };
    this.updateWorkflowAssignment(payload, "Graphics");
  }

  assignToSEO() {
    if (!this.selectedUserIdToAssign) {
      this.toastr.error("Please select an SEO user to assign.");
      return;
    }


    const selectedUserId = this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId;
    if (!selectedUserId) {

      this.toastr.error("SEO user not found.");
      return;
    }


    const selectedEpisode = this.singleEpisodeData[0];
    if (!selectedEpisode) return;
    const payload = {
      ...selectedEpisode,
      currentStage: "SEO",
      seoUser: this.selectedUserIdToAssign,
      assignedUserId: Number(selectedUserId),
      assignToSEOTeamOnDate: new Date().getTime(),
      seoTeamStartDate: new Date().getTime(),
      seoDueDate: new Date().getTime() + (2 * 24 * 60 * 60 * 1000),
      cid: this.cid
    };
    this.updateWorkflowAssignment(payload, "SEO");
  }

  assignToQualityCheck() {
    if (!this.selectedUserIdToAssign) {
      this.toastr.error("Please select a quality check user to assign.");
      return;
    }


    const selectedUserId = this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId;
    if (!selectedUserId) {

      this.toastr.error("Quality Check user not found.");
      return;
    }

    const selectedEpisode = this.singleEpisodeData[0];
    if (!selectedEpisode) return;
    const payload = {
      ...selectedEpisode,
      currentStage: "QUALITY_CHECK",
      qualityCheckUser: this.selectedUserIdToAssign,
      assignedUserId: Number(selectedUserId),
      assignToQualityCheckTeamOnDate: new Date().getTime(),
      qualityCheckStartDate: new Date().getTime(),
      qualityDueDate: new Date().getTime() + (2 * 24 * 60 * 60 * 1000),
      cid: this.cid
    };
    this.updateWorkflowAssignment(payload, "Quality Check");
  }

  assignToPublishing() {
    if (!this.selectedUserIdToAssign) {
      this.toastr.error("Please select a publishing user to assign.");
      return;
    }

    const selectedUserId = this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId;
    if (!selectedUserId) {

      this.toastr.error("Publishing user not found.");
      return;
    }
    const selectedEpisode = this.singleEpisodeData[0];
    if (!selectedEpisode) return;
    const payload = {
      ...selectedEpisode,
      currentStage: "PUBLISHING",
      publishingUser: this.selectedUserIdToAssign,
      assignedUserId: Number(selectedUserId),
      assignToPublishingTeamOnDate: new Date().getTime(),
      publishingStartDate: new Date().getTime(),
      publishingDueDate: new Date().getTime() + (2 * 24 * 60 * 60 * 1000),
      cid: this.cid
    };
    this.updateWorkflowAssignment(payload, "Publishing");
  }

  updateWorkflowAssignment(payload: any, stageName: string) {
    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success(`Episode assigned to ${stageName} successfully!`);
        this.getAllEpisodes();
        this.selectedUserIdToAssign = "";
        document.getElementById("closeViewModalButton")?.click();
      },
      (err: any) => {
        console.error(err);
        this.toastr.error(`Failed to assign episode to ${stageName}.`);
      }
    );
  }

  deleteIdSelect(id: any, list: any) {
    this.deleteId = id;
    this.recordId = list.id || list.episodeId;
    this.recordName = list.episodeName;
  }

  deleteEpisode() {
    this.tvProductionTrackerService.hardDeleteEpisode(this.deleteId).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Episode deleted successfully');
        this.getAllEpisodes();
        this.closePopUp();
        this.clearData();
      },
      (err: any) => {
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error deleting episode');
      }
    );
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
    this.deleteId = "";
  }

  closePopUp() {
    document.getElementById("closeModalButton1")?.click();
    document.getElementById("closeModalButton2")?.click();
    document.getElementById("closeModalButton3")?.click();
    document.getElementById("closeViewModalButton")?.click();
    this.recordId = "";
    this.recordName = "";
    this.episodeForm.reset();
    this.episodeUpdateForm.reset();
    this.formSubmit = false;
  }

  isMyNote(note: any): boolean {
    if (!note || note.userId === undefined || note.userId === null) return false;
    return Number(note.userId) === Number(this.loggedInUserId);
  }
}
